export { default } from './checkVerticalJustification'
